import { render, staticRenderFns } from "./qGoToOrder.vue?vue&type=template&id=5a56b4e2&"
import script from "./qGoToOrder.vue?vue&type=script&lang=ts&"
export * from "./qGoToOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports